// extracted by mini-css-extract-plugin
export default {"widthAdjusted":"app-registrationReports-bodyCells-FlagCommentsModalCell-FlagCommentsModalCell-module__jW0x5f6RhyQFzLoFx4sA"};